// Notice mode ships the tag loaders inert inside
// <template data-consent-deferred> blocks (server-rendered, so what's in them
// already honors the visitor's GPC carve-outs). Activation swaps each
// template for its content in place. Cloned <script> nodes carry the
// "already started" flag and never run, so every script is recreated —
// attributes and inline text copied — which makes the browser execute it on
// insertion (in order for inline scripts; async/src attributes respected).
export default function activateDeferredTags(doc = document) {
  doc.querySelectorAll('template[data-consent-deferred]').forEach((template) => {
    const fragment = template.content.cloneNode(true);

    fragment.querySelectorAll('script').forEach((inert) => {
      const script = doc.createElement('script');
      Array.from(inert.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
      script.text = inert.text;
      inert.parentNode.replaceChild(script, inert);
    });

    template.parentNode.replaceChild(fragment, template);
  });
}
